// extracted by mini-css-extract-plugin
export var resizer = "_fp-0";